/**
 * Categoria: Cadastro de Alunos e Matrículas (Operação)
 * Rotina comercial: Leads, Vendas e agendamento na grade.
 */
export const CADASTRO_MATRICULA = {
    id: "cadastro_matricula",
    title: "Cadastro de Alunos e Matrículas (Operação)",
    icon: "ph-light ph-user-plus",
    description: "A rotina comercial para lidar com Leads, realizar Vendas e agendar alunos na grade.",
    steps: [
        {
            id: "cad_fase1",
            title: "Fase 1 — Triagem e Cadastro (Lead)",
            description: "Todo usuário começa como um potencial cliente:",
            subItems: [
                {
                    id: "cad_base",
                    icon: "ph-light ph-user-focus",
                    title: "Realizar Cadastro Base",
                    content: `<p class="mb-2"><strong>Como realizar:</strong> Acesse <strong>Clientes > Criar Aluno</strong>. Preencha informações fundamentais como Nome Completo, E-mail e Telefone WhatsApp.</p>
                              <p class="mb-0"><strong>O que significa:</strong> O novo cadastro nasce com o status <strong>Prospect/Lead</strong>. Isso significa que ele é inelegível para matrículas regulares (recorrentes), pois ainda não tem um Plano Ativo atrelado a ele. O Lead <strong>só pode</strong> ser agendado em Turmas via "Aula Experimental".</p>`
                }
            ]
        },
        {
            id: "cad_fase2",
            title: "Fase 2 — Venda de Plano (PDV) e Efetivação",
            description: "Como um Lead se torna um Aluno Ativo:",
            subItems: [
                {
                    id: "pdv_venda",
                    icon: "ph-light ph-storefront",
                    title: "Nova Venda de Mensalidade",
                    content: `<p class="mb-0"><strong>Como realizar:</strong> Vá ao Perfil do Cliente (Lead) e clique em "Nova Venda". Adicione um plano recorrente ou de serviço ao carrinho.</p>`
                },
                {
                    id: "pdv_turmas",
                    icon: "ph-light ph-clock",
                    title: "Seleção de Turmas Obrigatórias",
                    content: `<p class="mb-0"><strong>Atenção:</strong> Se o plano for configurado como horários fixos (como aulas de natação), o PDV bloqueará a venda até que o vendedor acesse a Grade incorporada no Carrinho e selecione as turmas/dias compatíveis com o plano.</p>`
                },
                {
                    id: "pdv_fechamento",
                    icon: "ph-light ph-check-circle",
                    title: "Fechamento e Automações",
                    content: `<p class="mb-2">Após a confirmação do pagamento no PDV, processos silenciosos ocorrem:</p>
                              <ul>
                                  <li class="mb-1">O Status do aluno muda de "Lead" para <strong>"Ativo"</strong>.</li>
                                  <li class="mb-1"><strong>Matrícula Recorrente Mágica:</strong> O aluno é inserido nas listas de presença de todas as diárias (Sessões) das turmas escolhidas, até a data limite do contrato do Plano vendido.</li>
                                  <li>O Aluno e Vendedor podem ganhar XP de Bonificação automática, dependendo da configuração.</li>
                              </ul>`
                }
            ]
        },
        {
            id: "cad_fase3",
            title: "Fase 3 — Modalidades de Matrícula",
            description: "Regras de ouro de como uma matrícula opera em turmas de horários fixos:",
            subItems: [
                {
                    id: "mod_trial",
                    icon: "ph-light ph-flask",
                    title: "Agendamento Experimental (Trial)",
                    content: `<p class="mb-2"><strong>Regra:</strong> Apenas agenda a presença pontual do aluno para <strong>1 Único Dia</strong>.</p>
                              <p class="mb-0"><strong>Público Permitido:</strong> Apenas pessoas com Status Inativo, Suspenso ou Lead. Usado estritamente como conversão comercial para "testar" a academia.</p>`
                },
                {
                    id: "mod_regular",
                    icon: "ph-light ph-seal-check",
                    title: "Matrícula Regular",
                    content: `<p class="mb-2"><strong>Regra:</strong> Insere o aluno recorrentemente em <strong>Todas as Sessões Futuras</strong> disponíveis para aquela turma, dentro dos limites do plano.</p>
                              <p class="mb-0"><strong>Público Permitido:</strong> Apenas Alunos "Ativos" que efetivamente compraram Planos via PDV. Se o plano expirar, ele deixa de carregar para sessões futuras.</p>`
                }
            ]
        },
        {
            id: "cad_fase4",
            title: "Fase 4 — Gestão de Contratos e Exceções",
            description: "Intervenções manuais, ajustes de prazo e interrupções de serviço:",
            subItems: [
                {
                    id: "gestao_vencimento",
                    icon: "ph-light ph-calendar-plus",
                    title: "Adicionar ou Reduzir Dias",
                    content: `<p class="mb-2"><strong>O que significa:</strong> Permite alterar a data de validade de um plano vigente, seja para adicionar dias (ex: repor faltas, atestado médico, cortesia) ou reduzir dias, adiantando o fim do contrato.</p>
                              <p class="mb-0"><strong>Como realizar:</strong> No <em>Perfil do Aluno</em>, navegue até a sessão do Plano/Assinatura comprado. Clique no botão de Ações (três pontinhos) e escolha <strong>"Editar Vencimento"</strong>. Insira a nova data limite.</p>`
                },
                {
                    id: "gestao_suspensao",
                    icon: "ph-light ph-pause-circle",
                    title: "Suspender Plano (Trancamento)",
                    content: `<p class="mb-2"><strong>O que significa:</strong> Paralisa o uso do plano por um tempo determinado. Durante a suspensão, o aluno não tem acesso e os dias que seriam consumidos "congelam", sendo jogados para o final do contrato, prorrogando a sua validade final automaticamente.</p>
                              <p class="mb-0"><strong>Como realizar:</strong> Em Opções do Plano, escolha <strong>"Suspender"</strong>. No formulário, você agendará a data de <em>Início da Suspensão</em> e a data de <em>Retorno (Fim da Suspensão)</em>.</p>`
                },
                {
                    id: "gestao_cancelamento",
                    icon: "ph-light ph-prohibit",
                    title: "Cancelar um Plano/Contrato",
                    content: `<p class="mb-2"><strong>O que significa:</strong> Interrupção definitiva da prestação de serviços daquele plano. A operação é irreversível.</p>
                              <p class="mb-0"><strong>Como realizar:</strong> Em Opções do Plano, escolha <strong>"Cancelar"</strong>. Ao confirmar, o sistema corta imediatamente as recorrências e retira o aluno das turmas ligadas a esse plano. O aluno ficará Inativo caso não possua nenhum outro plano ativo vigente.</p>`
                }
            ]
        }
    ]
};
